module.exports = __webpack_public_path__ + "static/media/tz.53855cd8.svg";